"use client";

import { useState } from "react";
import { cx } from "./cx";
import { Button } from "./button";
import { Check, Copy, Icon } from "./icon";

export interface EmbedSnippetProps {
  /** The embed code text (built by M6 from the share config — never a literal here). */
  code: string;
  label?: string;
  className?: string;
  /** Fired on a successful copy — the M6 embed_snippet_copied analytics hook. */
  onCopy?: () => void;
}

/** Copy-to-clipboard code block — the M6 embed snippet composes from this. */
export function EmbedSnippet({ code, label = "Embed code", className, onCopy }: EmbedSnippetProps) {
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      onCopy?.();
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      // clipboard unavailable (permissions/iframe) — leave state unchanged
    }
  }

  return (
    <div className={cx("pz-embed-snippet", className)}>
      <div className="pz-embed-snippet__bar">
        <span className="pz-embed-snippet__label">{label}</span>
        <Button
          variant="ghost"
          size="sm"
          onClick={copy}
          className={cx(copied && "pz-embed-snippet__copied")}
          iconLeading={<Icon icon={copied ? Check : Copy} size="sm" />}
        >
          {copied ? "Copied" : "Copy"}
        </Button>
      </div>
      <code className="pz-embed-snippet__code">{code}</code>
    </div>
  );
}
